import moment from 'moment'
import 'moment-timezone'
import { DateFieldValue } from './types'

export function formatDateOnlyDisplay(value: string): string | null {
    if (value === '') {
        return null
    }

    const date = moment(value).hours(0).minutes(0).seconds(0).milliseconds(0)
    const dateFormat = new Intl.DateTimeFormat('nl-NL', {
        dateStyle: 'medium',
        timeZone: 'Europe/Amsterdam',
    })

    try {
        return dateFormat.format(date.toDate())
    } catch {
        return null
    }
}

export function formatDateTimeDisplay(value: string): string | null {
    if (value === '') {
        return null
    }

    const date = moment(value)
    const dateTimeFormat = new Intl.DateTimeFormat('nl-NL', {
        dateStyle: 'medium',
        timeStyle: 'medium',
        timeZone: 'Europe/Amsterdam',
    })

    try {
        return dateTimeFormat.format(date.toDate())
    } catch {
        return null
    }
}

/** Date field payload: calendar date only. */
export function serializeDateValue(m: moment.Moment): string {
    return m.format('YYYY-MM-DD')
}

/** Datetime field payload: same as pre-split DateTimeField (`moment.format()`). */
export function serializeDateTimeValue(m: moment.Moment): string {
    return m.format()
}

export function normalizeDateFieldValue(
    value: DateFieldValue | undefined
): DateFieldValue {
    if (value === null || value === undefined) {
        return null
    }

    if (
        typeof value === 'object' &&
        !moment.isMoment(value) &&
        !(value instanceof Date)
    ) {
        return value
    }

    const parsed = moment(value as string | Date | moment.Moment)
    if (!parsed.isValid()) {
        return value
    }

    return parsed.format('YYYY-MM-DD')
}
